import {useLanguageContext} from '../../../../context';
import CatItemSummary from './CatItemSummary';
import React from 'react';

const CategoriesSummary = ({selectedLocation}) => {
    const {I18n} = useLanguageContext();
    const handleClick = () => {
        // handleClick
    };
    return (
        <CatItemSummary
            type="category"
            selectedLocation={selectedLocation}
            action={{
                title: I18n.setup_categories,
                click: handleClick,
            }}
        />
    );
};

export default CategoriesSummary;
